
















































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class CreatePassword extends Vue {
  public $refs!: {
    pass1: HTMLFormElement;
    pass2: HTMLFormElement;
  };

  @Prop({ required: false, default: false })
  private disabled!: boolean;

  @Prop({ required: false, default: false })
  private confirm!: boolean;

  @Prop({ required: false, default: "" })
  private passwordLabel!: boolean;

  @Prop({ required: false, default: false })
  private autofocus!: boolean;

  private pass1 = "";
  private pass2 = "";
  private inFocus = false;

  public get password() {
    return this.pass1.length ? this.pass1 : this.pass1 || this.pass2;
  }

  public get isEightCharacters() {
    return this.password.length >= 8;
  }

  public get hasLetters() {
    return /[a-zA-Z]/.test(this.password);
  }

  public get hasUpperCaseLetters() {
    return /[A-Z]/.test(this.password);
  }

  public get hasLowerCaseLetters() {
    return /[a-z]/.test(this.password);
  }

  public get hasDigits() {
    return /[0-9]/.test(this.password);
  }

  public get hasSpecialCharacters() {
    return this.password.replace(/[A-Za-z0-9]/g, "").length > 0;
  }

  public get isConfirmed() {
    if (!this.confirm) return true;
    return this.pass1.length && this.pass1 === this.pass2;
  }

  public get isValid() {
    return this.isEightCharacters && this.hasLetters && this.hasDigits;
  }

  public get isValidConfirmed() {
    return this.isValid && this.isConfirmed;
  }

  public clearInputs() {
    this.pass1 = this.pass2 = "";
    this.inFocus = false;
  }

  public created() {
    if (this.autofocus) {
      this.$nextTick(() => {
        this.$refs.pass1.$el.querySelector("input").focus();
      });
    }
  }

  @Watch("isValidConfirmed")
  private isValidConfirmedWatch() {
    this.$emit("validated", this.isValidConfirmed ? this.password : "");
  }
}
